import { render, staticRenderFns } from "./DetailTotalCustomer.vue?vue&type=template&id=7e247f04"
import script from "./DetailTotalCustomer.vue?vue&type=script&lang=js"
export * from "./DetailTotalCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports